import React, {Component} from 'react';
import {Input} from 'reactstrap';
import PropTypes from 'prop-types';

import withManagers from '../../../../HOC/withManagers.jsx';

import './FilterManager.scss';

class FilterManager extends Component {
  static propTypes = {
    managers: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    };
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.value === undefined && prevProps.value !== undefined) {
      this.setState({
        value: 0
      })
    }
  }

  onChange = (event) => {
    this.setState({
      value: event.target.value
    });
    this.props.onChange({manager: event.target.value});
  };

  render() {
    return (
      <Input type="select" value={this.state.value} onChange={(e) => this.onChange(e)}>
        <option/>
        {this.props.managers.map((manager) => (
          <option value={manager.id} key={manager.id}>{manager.fullname}</option>
        ))}
      </Input>
    )
  }''
}

export default withManagers(FilterManager);